import React, { useCallback, useEffect, useRef, useState } from 'react';
import DataGrid, {
    Paging,
    Scrolling,
    Pager,
    SearchPanel,
    FilterRow,
    HeaderFilter,
    Column,
    ColumnChooser,
    ColumnFixing,
    FilterPanel,
    Button as ActionButton,
    Export,
    Selection,
    Summary,
    TotalItem
} from 'devextreme-react/data-grid';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Card, Col, Form, Modal, Row, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { COMPACTING_AUTHORIZATION } from '../../../store/programs/CompactingDivisionAuthorization/compactingDivAuthorization.reducer';
import { fetchCompactingAuthorizationData } from '../../../store/programs/CompactingDivisionAuthorization/compactingDivAuthorization.actions';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { exportDataGrid as exportDataGridToPdf } from 'devextreme/pdf_exporter';
import { jsPDF } from 'jspdf';
import { NAVIGATE_YARN_PO_DETAILS } from '../../../store/programs/YarnPO/yarnPO/yarnPO.actionsType';
import { NAVIGATE_COMPACTING_DIV_AUTHORIZATION_DETAILS } from '../../../store/programs/CompactingDivisionAuthorization/compactingDivAuthorization.actionsType';
import { EndDateReact, getSavedPageIndex, setGridPageIndex, statusChecker } from '../../../App/components/Common/Util';

const CompactingDivisionAuthorize = () => {
    let { compactingDivAuthData, compactingDivAuthSelectedvalue } = useSelector((state) => {
        return state[COMPACTING_AUTHORIZATION];
    });


    let dispatch = useDispatch();
    const allowedPageSizes = [10, 20, 50, 100];
    const renderTitleHeader = (data) => {
        return <div style={{ fontWeight: 'bold' }}>{data.column.caption}</div>;
    };
    // const onSelectionChanged = ({ selectedRowKeys, selectedRowsData }) => {
    //     console.log('selectedRowsData', selectedRowsData);
    //     localStorage.setItem('selectedRowsData', JSON.stringify(selectedRowsData));

    useEffect(() => {
        dispatch(fetchCompactingAuthorizationData())
    }, [dispatch])

    const onExporting = useCallback((e) => {
        if (e.format === 'xlsx') {
            const workbook = new Workbook();
            const worksheet = workbook.addWorksheet('Yarn Inward');
            exportDataGrid({
                component: e.component,
                worksheet,
                autoFilterEnabled: true
            }).then(() => {
                workbook.xlsx.writeBuffer().then((buffer) => {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Companies.xlsx');
                });
            });
            e.cancel = true;
        } else if (e.format === 'pdf') {
            const doc = new jsPDF();
            exportDataGridToPdf({
                jsPDFDocument: doc,
                component: e.component
            }).then(() => {
                doc.save('YarnInward.pdf');
            });
        }
    });

    //     dispatch(createCompactingDCDetailsUserForm('fldInwardDia', selectedRowsData[0]?.fldInwardDia));
    //     dispatch(createCompactingDCDetailsUserForm('fldFKInwardDia', selectedRowsData[0]?.fldFKInwardDia));
    //    // dispatch(createCompactingDCDetailsUserForm('fldFKRequiredDia',selectedRowsData[0]?.fldFKRequiredDia));
    //     dispatch(createCompactingDCDetailsUserForm('fldSalesOrderNo', selectedRowsData[0]?.fldSalesOrderNo));
    //     dispatch(createCompactingDCDetailsUserForm('fldFKSaleOrder', selectedRowsData[0]?.fldFKSaleOrderNo));
    //     dispatch(createCompactingDCDetailsUserForm('fldFKYarnCount', selectedRowsData[0].fldFKYarnCounts));
    //     dispatch(createCompactingDCDetailsUserForm('fldStyleDescription', selectedRowsData[0].fldStyleDescription));
    //     dispatch(createCompactingDCDetailsUserForm('fldGSM', selectedRowsData[0]?.fldGSM));
    //     dispatch(createCompactingDCDetailsUserForm('fldFKColour', selectedRowsData[0]?.fldFKColour));
    //     dispatch(createCompactingDCDetailsUserForm('fldColourShade', selectedRowsData[0]?.fldColourShade));
    //     dispatch(createCompactingDCDetailsUserForm('fldColour', selectedRowsData[0]?.fldColour));
    //     dispatch(createCompactingDCDetailsUserForm('fldQuantity', selectedRowsData[0]?.fldQuantity));
    //     dispatch(createCompactingDCDetailsUserForm('fldFabricname', selectedRowsData[0]?.tblFabricname));
    //     dispatch(createCompactingDCDetailsUserForm('fldFKStyle', selectedRowsData[0]?.fldFKStyleNumber));
    //     dispatch(createCompactingDCDetailsUserForm('fldStyleNumber', selectedRowsData[0]?.fldStyleNumber));
    //     dispatch(createCompactingDCDetailsUserForm('fldFKHSNCode', selectedRowsData[0].fldFKHSNCode));
    //     dispatch(createCompactingDCDetailsUserForm('fldFKUOM', selectedRowsData[0].fldFKUOM));
    //     dispatch(createCompactingDCDetailsUserForm('fldFKFabricGroup', selectedRowsData[0].fldFKFabricGroup));
    //     dispatch(createCompactingDCDetailsUserForm('fldFKFabricType', selectedRowsData[0]?.fldFKFabric));
    //     dispatch(createCompactingDCDetailsUserForm('fldFKGSM', selectedRowsData[0].fldFKGSM));
    //     dispatch(createCompactingDCDetailsUserForm('fldFKNoofRolls', selectedRowsData[0].fldFKNoofRolls));
    //     dispatch(createCompactingDCDetailsUserForm('fldRequiredDia', selectedRowsData[0].fldRequiredDia));
    //     dispatch(createCompactingDCDetailsUserForm('fldDespatchQuantity',selectedRowsData[0].fldDespatchQuantity));
    //     dispatch(createCompactingDCDetailsUserForm('fldDespatchQuantity',selectedRowsData[0].fldBalanceQuantity));
    // };
    console.log("StatusChecker", statusChecker);
    return (
        <Card>
            <Card.Body>
                <div>
                    <DataGrid
                        dataSource={compactingDivAuthData}
                        keyExpr="fldId"
                        showBorders={true}
                        columnAutoWidth={true}
                        //allowColumnReordering={true}
                        rowAlternationEnabled={true}
                        onExporting={onExporting}
                        hoverStateEnabled={true}
                        height={'85vh'}
                        allowColumnResizing={true}
                        columnResizingMode="widget"
                        onOptionChanged={(e) => {
                            if (e.fullName === 'paging.pageIndex') {
                                setGridPageIndex(e.value)
                            }
                        }}
                    >
                        <FilterRow visible={true} applyFilter="auto" />
                        <FilterPanel visible={true} />
                        <HeaderFilter visible={true} />
                        <SearchPanel visible={true} width={240} placeholder="Search..." />
                        <ColumnChooser enabled={true} />
                        <ColumnFixing enabled={true} />
                        <Scrolling rowRenderingMode="virtual"></Scrolling>
                        <Paging
                            defaultPageSize={10}
                            defaultPageIndex={getSavedPageIndex()}
                        // defaultPageIndex={gridPageIndex}
                        // pageIndex={gridPageIndex}
                        // onPageIndexChange={changePageIndex}
                        />
                        <Pager
                            visible={true}
                            showPageSizeSelector={true}
                            allowedPageSizes={allowedPageSizes}
                            showNavigationButtons={true}
                            showInfo={true}
                            // displayMode="compact"
                            infoText="Page #{0}. Total: {1} ({2} items)"
                        />
                        <Column headerCellRender={renderTitleHeader} dataField="fldStyle" caption="Style Number"></Column>
                        {/* <Column headerCellRender={renderTitleHeader} dataField="fldSalesOrder" caption="Sales Order No"></Column> */}
                        <Column headerCellRender={renderTitleHeader} dataField="fldSupplierName" caption="Supplier Name"></Column>
                        <Column headerCellRender={renderTitleHeader} dataField="fldGRNNo" caption="Dyeing DC No"></Column>
                        <Column
                            headerCellRender={renderTitleHeader}
                            dataType="date"
                            format="dd/MM/yyyy"
                            dataField="fldSupplierDCDate"
                            caption="DC Date"
                        ></Column>
                        <Column headerCellRender={renderTitleHeader} dataField="fldColours" caption="Colors"></Column>
                        <Column headerCellRender={renderTitleHeader} dataField="fldDyeingDCQty" caption="DC Qty"></Column>
                        <Column headerCellRender={renderTitleHeader} dataField="fldRNNo" caption="Receiving Note No"></Column>
                        <Column
                            headerCellRender={renderTitleHeader}
                            dataType="date"
                            format="dd/MM/yyyy"
                            dataField="fldRNDate"
                            caption="Receiving Date"
                        ></Column>
                        <Column headerCellRender={renderTitleHeader} dataField="fldInwardQty" caption="Receiving Qty"></Column>
                        <Column headerCellRender={renderTitleHeader} dataField="fldRate" caption="Rate"></Column>
                        <Column headerCellRender={renderTitleHeader} caption="Status" type="buttons" width={160}>
                            <ActionButton
                                hint="Status"
                                visible={true}
                                onClick={(e) => {
                                    //   localStorage.setItem('isBack', gridPageIndex);
                                    dispatch({
                                        type: NAVIGATE_COMPACTING_DIV_AUTHORIZATION_DETAILS,
                                        updatePayload: { compactingDivAuthSelectedvalue: e.row.data }
                                    });
                                }}
                                render={(e) => {
                                    const isAuthorized = e.row.data?.fldIsAuthorized === true; // Check if the status is 'Authorized'
                                    return isAuthorized ? <button className="btn btn-primary btn-green btn-sm m-0 justify-content-center" type="button">
                                        Authorized
                                    </button> : ( // Conditionally render the button
                                        <button className="btn btn-primary btn-sm m-0 justify-content-center" type="button">
                                            Not Prepared
                                        </button>
                                    );
                                }}
                            //disabled={(e)=>statusChecker(e.row.data) === 'Authorized'}
                            />
                        </Column>
                        {/* <Column headerCellRender={renderTitleHeader} dataField="fldFKNoofRolls" caption="NO. Of Rolls"></Column>
           

            <Column headerCellRender={renderTitleHeader} caption="Pending Qty" type="buttons" width={110}>
                <ActionButton
                    render={(e) => (
                        <>{e.row.data.fldBalanceQuantity}</>
                    )}
                />
            </Column> */}
                        {/* <Column headerCellRender={renderTitleHeader} dataField="PendingQty" caption="Pending Qty"></Column> */}
                        {/* <Column headerCellRender={renderTitleHeader} dataField="fldBagWeight" caption="Bag Weight(Kgs)"></Column> */}
                        {/* <Column headerCellRender={renderTitleHeader} dataField="FldRate" caption="Rate Per KG"></Column>
            <Column headerCellRender={renderTitleHeader} dataField="FldDiscountPercentage" caption="Discount %"></Column>
            <Column headerCellRender={renderTitleHeader} dataField="FldIGSTPercentage" caption="IGST%"></Column>
            <Column headerCellRender={renderTitleHeader} dataField="FldSGSTPercentage" caption="SGST%"></Column>
            <Column headerCellRender={renderTitleHeader} dataField="FldCGSTPercentage" caption="CGST%"></Column>
            <Column headerCellRender={renderTitleHeader} dataField="FldGSTValue" caption="GST Value"></Column> */}

                        <Summary>
                            <TotalItem column="fldDescription" summaryType="count" />
                        </Summary>
                    </DataGrid>
                </div>
            </Card.Body>
        </Card>
    );
};

export default CompactingDivisionAuthorize;
